const menu = {
    top: [
        { title:"Users" , path:"/users" , icon:"user"},
        { title: 'Blogs', path: '/blogs', icon: 'blog' },
        { title: 'Places', path: '/places', icon: 'map-marker-alt' },
        { title: 'News', path: '/news', icon: 'newspaper:r' },
    ],
    footer: [
        { title:"Privacy Policy" , path:"/privacy-policy.html" , icon:"circle"},
        { title:"Terms & Conditions" , path:"/terms-conditions.html" , icon:"circle"},
        { title:"Contact Us" , path:"/contact-us.html" , icon:"circle"},
    ],
};

export default menu;